import template from './manageObligationBasisLinesModal.html';
import controller from './manageObligationBasisLinesModal.controller';

let ManageObligationBasisLinesModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: 'hmodal-info animated zoomIn'
};

ManageObligationBasisLinesModalComponent.template = template;
ManageObligationBasisLinesModalComponent.controller = controller;

export default ManageObligationBasisLinesModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/manageObligationBasisLinesModal/manageObligationBasisLinesModal.component.js